import { render, staticRenderFns } from "./BtnSubmit.vue?vue&type=template&id=080573f8&scoped=true"
import script from "./BtnSubmit.vue?vue&type=script&lang=js"
export * from "./BtnSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080573f8",
  null
  
)

export default component.exports